export const FORGOT_PASSWORD_REQUEST = "FORGOTPASSWORDREQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOTPASSWORDSUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOTPASSWORDFAILURE";